const DEFAULT = 'TeleConsult';

/*
HOME
PRACTITIONER_DASHBOARD
PRACTITIONER_LOGIN
PATIENT_LOGIN
PATIENT_MEETING
*/
export default (state = DEFAULT, action) => {
  switch (action.type) {
    case 'HOME':
      return `Welcome | ${DEFAULT}`;
    case 'PRACTITIONER_DASHBOARD':
      return `Dashboard | ${DEFAULT}`;
    case 'PRACTITIONER_LOGIN':
      return `Login | ${DEFAULT}`;
    case 'PRACTITIONER_REGISTER':
      return `Register | ${DEFAULT}`;
    case 'PATIENT_LOGIN':
      return `Welcome | ${DEFAULT}`;
    case 'PATIENT_MEETING':
      return `Consult | ${DEFAULT}`;
    default:
      return state;
  }
};
